import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FareOptimisationSummaryComponent } from './fare-optimisation-summary.component';
import { BtnModule } from "libraries/ui_button/btn.module";
import { RouterModule } from "@angular/router";
import { SectorsAirSimpleListModule } from "libraries/component/sectors-air-simple-list/sectors-air-simple-list.module";


@NgModule({
    declarations: [
        FareOptimisationSummaryComponent,
    ],
    exports: [
        FareOptimisationSummaryComponent,
    ],
    imports: [
        CommonModule,
        BtnModule,
        RouterModule,
        SectorsAirSimpleListModule
    ]
})
export class FareOptimisationSummaryModule {
}
